import { DemurrageDetentionSearchCriteria } from '../models/shipment.model';
import { MatDialogRef } from '@angular/material/dialog';
import { ExportDialogComponent } from '../../../../../ui-kit';
import {
  DemurrageDetentionStatisticFilterModel,
  ShipmentFiltersDatepickerRangeOutput,
} from '../models/shipment-filters.model';

export class DemurrageDetentionLoad {
  public static readonly type = '[DemurrageDetention] Load';

  constructor(
    public payload: {
      searchCriteria: DemurrageDetentionSearchCriteria;
    },
  ) {}
}

export class DemurrageDetentionStatisticsLoad {
  public static readonly type = '[DemurrageDetention] Statistics Load';

  constructor(
    public payload: {
      searchCriteria: DemurrageDetentionSearchCriteria;
    },
  ) {}
}

export class DemurrageDetentionExportToFileStart {
  public static readonly type = '[DemurrageDetention] Start';

  constructor(
    public payload: {
      reportName: string;
      searchRequestView: {
        filter: ShipmentFiltersDatepickerRangeOutput;
        statisticFilter: DemurrageDetentionStatisticFilterModel;
      };
      dialogRef: MatDialogRef<ExportDialogComponent>;
      navigationNeeded: boolean;
    },
  ) {}
}

export class DemurrageDetentionInitialState {
  public static readonly type = '[DemurrageDetention] Set Initial State';
}
